export function formatPrice(priceObj) {
  return !!priceObj ? price(priceObj.priceCents, priceObj.currency) : 'N/A'
}

export function price(valueInCents, currency) {
  let value = Math.abs(valueInCents / 100)
  if (!Number.isInteger(value)) {
    value = value.toFixed(2)
  }

  const prefix = valueInCents < 0 ? '-' : ''

  switch (currency) {
    case 'EUR':
      return `${prefix}€${value}`
    case 'USD':
      return `${prefix}$${value}`
    case 'AUD':
      return `${prefix}AU$${value}`
    default:
      return `${prefix}${value}${currency}`

  }
}

/**
 * Join array of strings with commas (,) and "and".
 */
export function formatListToUserReadableString(list) {
  if (list.length < 3) { return list.join(' and ') }

  return `${list.slice(0, - 1).join(', ')}, and ${list[list.length - 1]}`
}
